var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContact1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.3022 13.1562C32.6687 13.5952 33.6209 14.8998 33.6209 16.3977V23.0229C33.6209 24.7789 32.3116 26.2691 30.5602 26.4128C30.0346 26.4546 29.5091 26.4932 28.9835 26.5241V31.3022L24.3461 26.6648C22.2531 26.6648 20.1818 26.5798 18.1321 26.4128C17.6859 26.3768 17.2518 26.2494 16.8568 26.0388M31.3022 13.1562C31.0633 13.0793 30.8165 13.03 30.5664 13.0093C26.4267 12.6657 22.2656 12.6657 18.1259 13.0093C16.3776 13.1546 15.0714 14.6432 15.0714 16.3977V23.0229C15.0714 24.3168 15.7825 25.4653 16.8568 26.0388M31.3022 13.1562V10.2594C31.3022 7.75365 29.5214 5.58182 27.0358 5.25875C23.8373 4.84416 20.6154 4.63659 17.3901 4.63735C14.1208 4.63735 10.9009 4.84912 7.7444 5.25875C5.25877 5.58182 3.47803 7.75365 3.47803 10.2594V19.8834C3.47803 22.3892 5.25877 24.561 7.7444 24.8841C8.63632 25 9.53287 25.1005 10.4341 25.1839V32.4615L16.8568 26.0388",
    stroke: "#959595",
    strokeWidth: 2.31868,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContact1);
export default __webpack_public_path__ + "static/media/contact1.4c75e78630b96be8f51beb9a04a568ab.svg";
export { ForwardRef as ReactComponent };